export default [
  {
    path: '/plans/containerArea/list',
    name: 'plans.containerArea.list',
    component: () => import('@/views/modules/plans/container-area-plan/list'),
    meta: {
      module: 'plans.containerArea',
      pageTitle: 'CONTAINER_AREA_PLAN_LIST_TITLE',
      breadcrumb: [
        { 
          text: 'CONTAINER_AREA_PLAN_LIST_TITLE', 
          active: true, 
        }
      ],
    }
  },
  {
    path: '/plans/containerArea/create',
    name: 'plans.containerArea.create',
    component: () => import('@/views/modules/plans/container-area-plan/create'),
    meta: {
      module: 'plans.containerArea',
      pageTitle: 'CONTAINER_AREA_PLAN_CREATE_TITLE',
      breadcrumb: [
        { 
          text: 'CONTAINER_AREA_PLAN_LIST_TITLE', 
          to: {
            name: 'plans.containerArea.list'
          } 
        },
        { 
          text: 'CONTAINER_AREA_PLAN_CREATE_TITLE', 
          active: true
        }
      ],
    }
  },
  {
    path: '/plans/containerArea/:id/edit',
    name: 'plans.containerArea.edit',
    component: () => import('@/views/modules/plans/container-area-plan/edit'),
    meta: {
      module: 'plans.containerArea',
      pageTitle: 'CONTAINER_AREA_PLAN_EDIT_TITLE',
      breadcrumb: [
        { 
          text: 'CONTAINER_AREA_PLAN_LIST_TITLE', 
          to: {
            name: 'plans.containerArea.list'
          } 
        },
        { 
          text: 'CONTAINER_AREA_PLAN_EDIT_TITLE', 
          active: true
        }
      ],
    }
  },
]
